import styled from 'styled-components'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import { RegularButton } from '../../atoms'
import React from "react";
import {colors} from "../../../assets";
import { tokens } from '../../../assets/tokens';

const ProfileButtonsStyled = styled.div`
  /* Estado, acciones y paginador en una fila alineada a la derecha */
  .buttons-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 12px;
  }

  .header-actions {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
  }

  .header-pagination-count {
    display: inline-block;
    padding-left: 15px;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    color:#666;
    opacity: 0.75 !important;
  }

  .header-profile-arrows {
    margin-left: 15px;
    button {
      padding: 7px;
      margin-left: 10px;
    }
    svg {
      height: 25px;
      width: 30px;
    }
  }

  .currentItemNumber{
    color: ${colors.grey4};
  }
`

export const HeaderButton = styled(props => <RegularButton {...props}/>)`
  margin-left: 10px;
`

export const ButtonContainer = styled(props => <ButtonGroup {...props}/>)`
  margin: 35px 0;
`

export default ProfileButtonsStyled

// Disparador del estado con la forma de los selects de Velora (40 px, borde 1.5, radio 8) y el
// color del estado en un punto
export const StatusSelect = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  min-width: 200px;
  padding: 0 12px;
  font-family: ${tokens.typography.fontFamily.primary};
  font-size: 14px;
  font-weight: 400;
  color: ${tokens.color.text.primary};
  background: ${tokens.color.background.default};
  border: 1.5px solid ${tokens.color.border.default};
  border-radius: 8px;
  cursor: pointer;

  :hover,
  :focus-visible {
    border-color: ${props => props.theme.primary};
    outline: none;
  }

  .status-dot {
    flex-shrink: 0;
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }

  .status-label {
    flex: 1 1 auto;
    text-align: left;
  }

  svg {
    flex-shrink: 0;
    color: ${tokens.color.text.secondary};
  }
`
